export type Appearance = 'system' | 'light' | 'dark';
export function readAppearance(): Appearance {
  try {
    const value = localStorage.getItem('orbit-mind.appearance');
    return value === 'light' || value === 'dark' ? value : 'system';
  } catch {
    return 'system';
  }
}
export function applyAppearance(value: Appearance): void {
  document.documentElement.dataset.appearance = value;
}
